export default "__VITE_ASSET__iGuMDKL9__"